import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { JobStatus, ProductDataDistribution, ProductIdentification } from '@/domain/product-search/types';
import { ActionStatus } from '@/application/types';
import { jobQualifierMap } from '@/helpers/data';

const productSearchState = namespace('productSearch');

@Component
export default class DataDistributionTab extends Vue {

  @productSearchState.State
  readonly getProductIdentificationsByEANStatus!: ActionStatus;

  @productSearchState.State
  readonly getProductIdentificationStatus!: ActionStatus;

  @productSearchState.State
  readonly getProductDataDistributionStatus!: ActionStatus;

  @productSearchState.State
  readonly currentProductDataDistribution!: ProductDataDistribution | null;

  @productSearchState.State
  readonly currentProductIdentification!: ProductIdentification | null;

  readonly jobQualifierMap = jobQualifierMap;

  get isLoadingProductIdentification(): boolean {
    return this.getProductIdentificationStatus === ActionStatus.InProgress
      || this.getProductIdentificationsByEANStatus === ActionStatus.InProgress;
  }

  get isLoadingDataDistribution(): boolean {
    return this.isLoadingProductIdentification || this.getProductDataDistributionStatus === ActionStatus.InProgress;
  }

  isJobFailed(status: JobStatus): boolean {
    const validStatuses: JobStatus[] = ['DONE', 'SCHEDULED'];

    return !validStatuses.includes(status);
  }

}
